/** Cache only public application assets. Account/content caches remain scoped in IndexedDB. */
export async function cacheOfflineShell() {
  if (!("serviceWorker" in navigator)) return;
  try {
    await navigator.serviceWorker.register("/sw.js");
    const registration = await navigator.serviceWorker.ready,
      worker = registration.active;
    if (!worker) return;
    const urls = performance
      .getEntriesByType("resource")
      .map((entry) => entry.name)
      .filter((url) => new URL(url).origin === location.origin);
    const channel = new MessageChannel();
    await new Promise<void>((resolve) => {
      const timeout = setTimeout(resolve, 10000);
      channel.port1.onmessage = () => {
        clearTimeout(timeout);
        channel.port1.close();
        resolve();
      };
      worker.postMessage({ type: "CACHE_SHELL", urls }, [channel.port2]);
    });
    window.dispatchEvent(new Event("ca-shell-cached"));
  } catch {
    /* Current tab and local writes still work when shell caching is unavailable. */
  }
}
